import React from "react";

export default ({ filter, onChange }) => (
  <input
    className="user-input-fields user-input-fields-left"
    value={filter ? filter.value : ""}
    onChange={(event) => onChange(event.target.value)}
  />
);
